// JS for additional SEO content on subset of locale-only pages

(function() {
  const $showHideTableContentButton = $('.js-toggle-previous-table-content-visible');

  $showHideTableContentButton.on('click', function() {
    let $button = $(this);
    const $table = $button.prev('.js-table');

    if ($table.attr('data-visible') == 'limited') {
      $table.attr('data-visible', 'full');
      $button.find('span').text('Fewer');
    } else {
      $table.attr('data-visible', 'limited');
      $button.find('span').text('More');
    }
  });
})();
